function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  // Masquer le bouton radio d'origine\n  display: none;\n\n  // Affichage par d\xE9faut du bouton radio personnalis\xE9\n  & + label:before {\n    background: #fff;\n    border: 2px solid #ccc;\n    border-radius: 50%;\n    margin-top: -3px;\n    margin-right: 6px;\n    display: inline-block;\n    vertical-align: middle;\n    content: \"\";\n    width: 17px;\n    height: 17px;\n  }\n\n  // Affichage du bouton radio personnalis\xE9 quand il est s\xE9lectionn\xE9\n  &:checked + label:before {\n    box-shadow: inset 0px 0px 0px 2px #fff;\n    background: ", ";\n    border-color: ", ";\n  }\n\n  & label {\n    font: 400 16px Arial;\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { FieldBase } from "./FieldBase";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import "./RadioField.css";
var StyledInput = styled.input(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.color;
}); // #region HOOK

/**
 * Représente un radio button
 * @class
 * @category Fields
 * @param {Fields.RadioField.propTypes} props Les propriétés du composant
 */

function RadioField(props) {
  // Récupération des props
  var items = props.items,
      name = props.name,
      textColor = props.textColor,
      value = props.value;
  return /*#__PURE__*/React.createElement(FieldBase, _extends({}, props, {
    render: function render(handleChange) {
      return /*#__PURE__*/React.createElement("div", {
        className: "RadioField-Container"
      }, items && items.map(function (item) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.value,
          className: "RadioField-Item"
        }, /*#__PURE__*/React.createElement(StyledInput, {
          color: textColor,
          type: "radio",
          id: name + "_" + item.value,
          name: name,
          value: item.value,
          onChange: handleChange,
          checked: value === item.value ? true : false
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: name + "_" + item.value,
          style: {
            color: textColor
          }
        }, item.label));
      }));
    }
  }));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link RadioField}
 * @typedef {Object} RadioField.propTypes
 * @property {string} name Le nom du champ
 * @property {string} tooltip Le texte du champ
 * @property {shape[]} items Un tableau de _shape_ (value {number}, label {string}) contenant la liste des valeurs
 * @property {number} [value=-1] La valeur sélectionnée
 * @property {string} [backgroundColor=#fff] La couleur de fond
 * @property {string} [textColor=#000] La couleur du texte
 * @property {string} [width=100%] La largeur du champ
 * @property {string} [icon=null] L'icône du champ
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 * @property {function} [onClickIcon=null] La fonction de callback de l'évènement onClick
 * @property {function} [onMouseEnterIcon=null] La fonction de callback de l'évènement onMouseEnter de l'icône
 * @property {boolean} [obligatory=false] true pour rendre le champ obligatoire
 * @property {boolean} [readonly=false] true pour désactiver le champ
 */


RadioField.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  value: PropTypes.number,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  width: PropTypes.string,
  icon: PropTypes.string,
  keepSpaceIcon: PropTypes.bool,
  onClickIcon: PropTypes.func,
  onMouseEnterIcon: PropTypes.func,
  obligatory: PropTypes.bool,
  readonly: PropTypes.bool
} : {};
/*
  Valeurs par défaut des propriétés
*/

RadioField.defaultProps = {
  value: -1,
  backgroundColor: "#fff",
  textColor: "#000",
  width: "100%",
  icon: null,
  keepSpaceIcon: false,
  onClickIcon: null,
  onMouseEnterIcon: null,
  obligatory: false,
  readonly: false
}; // #endregion

export { RadioField };